import { PropertyFilter, PropertyFilterType } from 'components/ListTable/types';
import { useNewFilters } from 'hooks/useFilters';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useConnectedPartners } from 'services/repositories/partners/partners';
import { addPartnersToFiltersConfig } from 'support/helpers/filters/filters';

export enum PaymentReconciliationFilterKey {
  externalMessageRef = 'external_message_ref',
  partnerId = 'partner_id',
  relatedDocumentDateBetween = 'related_document_date_between',
  payment_reconciliation_status = 'payment_reconciliation_status',
}

export const useReconciliationFilters = (tab: string) => {
  const { t } = useTranslation();
  const defaultFilterConfig = useMemo<Array<PropertyFilter>>(
    () => [
      {
        key: PaymentReconciliationFilterKey.externalMessageRef,
        type: PropertyFilterType.search,
        placeholder: t('paymentReconciliation:list.filter.search.label'),
        value: '',
      },
      {
        key: PaymentReconciliationFilterKey.partnerId,
        type: PropertyFilterType.dropdown,
        label: t('transactions:list.filter.partnerOptions.label'),
        value: '',
        dropDownOptions: {
          dropdownValues: [],
        },
        eventDetails: {
          event: 'filter_changed',
          properties: {
            filter_type: 'partner',
          },
        },
      },
      {
        key: PaymentReconciliationFilterKey.relatedDocumentDateBetween,
        type: PropertyFilterType.date,
        placeholder: t('paymentReconciliation:list.filter.rangeDate.label'),
        value: '',
      },
    ],
    [t],
  );

  const { data: connectedPartnersData } = useConnectedPartners();
  const filterConfig = useMemo(
    () =>
      addPartnersToFiltersConfig(defaultFilterConfig, PaymentReconciliationFilterKey.partnerId, connectedPartnersData),
    [connectedPartnersData, defaultFilterConfig],
  );

  const { filters, filterValues, updateFilter, updateFilters, clearAllFilters } = useNewFilters(filterConfig, tab);

  return {
    filters,
    filterValues,
    updateFilter,
    updateFilters,
    clearAllFilters,
  };
};
